(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('[data-collection-carousel]').forEach((carousel) => {
    const viewport = carousel.querySelector('[data-collection-viewport]');
    const track = carousel.querySelector('[data-collection-track]');
    const cards = [...carousel.querySelectorAll('.mock-category')];
    const previous = carousel.querySelector('[data-collection-previous]');
    const next = carousel.querySelector('[data-collection-next]');

    if (!viewport || !track || cards.length <= 6) return;

    let index = 0;
    let timer;

    const stepSize = () => {
      const gap = Number.parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return cards[0].getBoundingClientRect().width + gap;
    };

    const moveTo = (nextIndex) => {
      index = (nextIndex + cards.length) % cards.length;
      viewport.scrollTo({
        left: index * stepSize(),
        behavior: reduceMotion.matches ? 'auto' : 'smooth',
      });
    };

    const stop = () => {
      window.clearInterval(timer);
    };

    const start = () => {
      stop();
      if (reduceMotion.matches || document.hidden) return;
      timer = window.setInterval(() => moveTo(index + 1), 3000);
    };

    previous?.addEventListener('click', () => {
      moveTo(index - 1);
      start();
    });

    next?.addEventListener('click', () => {
      moveTo(index + 1);
      start();
    });

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', start);
    reduceMotion.addEventListener('change', start);
    window.addEventListener('resize', () => moveTo(index));

    start();
  });
})();
